<template>
    <div class="card cursor-pointer p-2 pl-3" :class="[selected ? 'border-primary' : 'border-light', hovered ? 'font-weight-bold bg-primary' : 'bg-light']"
         @click="selected = !selected" @mouseenter="hovered = true" @mouseleave="hovered = false">
        <span :class="{'font-weight-bold': selected}">
            {{ series.title[$i18n.locale] }}
        </span>
    </div>
</template>

<script>
export default {
    name: "SeriesSelection",
    props: {
        series: {
            type: Object
        },
    },
    data: () => ({
        selected: false,
        hovered: false,
    }),
    watch: {
        selected: function(val) {
            this.$emit('change', this.series.id);
        }
    }
}
</script>

<style scoped>
    .border-light {border: 1px solid darkgray}
</style>
